import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {SegurosBienes} from '../_models/seguros-bienes';
import {SegurosBienesTipoConstruccion} from '../_models/seguros-bienes-tipo-construccion';

@Injectable({
  providedIn: 'root'
})
export class SegurosBienesTipoConstruccionService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/segurosBienesTipoConstruccion/';

  constructor(private httpClient: HttpClient, private autServicio: AutenticacionService) { }

  listadoPorIdSeguroBien( idSeguroBien: string) {
    return this.httpClient.get( `${this.rutServicio}idSeguroBien/${idSeguroBien}` ).pipe( map( res => res as SegurosBienesTipoConstruccion[] ) );
  }

  listadoPorIdTipoConstruccionEnabled( idSeguroBien: string ) {
    return this.httpClient.get( `${this.rutServicio}idSeguroBien/${idSeguroBien}/enabled` ).pipe( map( res => res as SegurosBienesTipoConstruccion[] ) );
  }
  listadoPorIdSeguro( id: string ) {
    return this.httpClient.get( `${this.rutServicio}idSeguro/${id}/enabled` ).pipe( map( res => res as SegurosBienesTipoConstruccion[] ) );
  }

  listadoEnabled() {
    return this.httpClient.get( `${this.rutServicio}enabled` ).pipe( map( res => res as SegurosBienesTipoConstruccion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( `${this.rutServicio}${id}` ).pipe( map( res => res as SegurosBienes ) );
  }

  crear( regCrear: SegurosBienesTipoConstruccion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SegurosBienes ) );
  }

  actualizar( regActualizar: SegurosBienesTipoConstruccion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: any ) {
    regActualizar.map( ( s: SegurosBienesTipoConstruccion ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServicio + 'bulk', regActualizar ).pipe( map( res => res as SegurosBienesTipoConstruccion[] ) );
  }

}
